import APIController from '../core-api-controller';

export const fetchFilterStatusesApi = (paramsStr = '', paramsObj = {}) => {
  const path = `${APIController.endpointApi}/statuses/list${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const fetchFilterLabelsApi = (paramsObj = {}, paramsStr = '') => {
  const path = `${APIController.endpointApi}/labels${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const fetchTypeApi = (paramsStr = '', paramsObj = {}) => {
  const path = `${APIController.endpointApi}/types/list${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const fetchStatesApi = (paramsStr = '', paramsObj = {}) => {
  const path = `${APIController.endpointApi}/patients/fetch_states${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const fetchAmericanStatesApi = (paramsStr = '', paramsObj = {}) => {
  const path = `${APIController.endpointApi}/states${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const fetchUserStatesApi = (paramsStr = '', paramsObj = {}) => {
  const path = `${APIController.endpointApi}/client_user/users/fetch_states${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const fetchPharmaciesApi = (paramsStr = '', paramsObj = {}) => {
  const path = `${APIController.endpointApi}/pharmacies${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const shareFilterApi = (id, data = {}) => {
  const path = `${APIController.endpointApi}/user_filters/${id}/share`;
  return APIController.postCallback(path, data);
};

export const fetchJourneyStagesApi = (paramsStr = '', paramsObj = {}) => {
  const path = `${APIController.endpointApi}/journey_stages/list${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const fetchPrescriptionsApi = (paramsStr = '', paramsObj = {}) => {
  const path = `${APIController.endpointApi}/prescriptions/list${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};
